export { default as React } from "react";
export * as styled from "styled-components";
export * from "./components/Atoms";
export * from "./components/Molecules";
export * from "./components/Organisms";
export * from "./hooks";
export * from "./providers";
import { ids } from "@icarros/theme-react";
const GlobalStyles = ids.GlobalStyles;
export { GlobalStyles };
//# sourceMappingURL=index.js.map